import DiagnosticsScreen from 'pages/diagnostics';

export default function DiagnosticsPage() {
  return <DiagnosticsScreen />;
}
